/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LOCAL_STORE_TOKEN } from 'constant';

function PrivateRoute() {
  const token = localStorage.getItem(LOCAL_STORE_TOKEN);
  return token && token !== 'null' ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
